import { render, staticRenderFns } from "./chat-form.vue?vue&type=template&id=e0e754f2&"
import script from "./chat-form.vue?vue&type=script&lang=js&"
export * from "./chat-form.vue?vue&type=script&lang=js&"
import style0 from "./chat-form.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "chat-form.vue"
export default component.exports